"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_router_dom_1 = require("react-router-dom");
require("./NavMenu.css");
var NavMenu = /** @class */ (function (_super) {
    __extends(NavMenu, _super);
    function NavMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            challengeHack: "ICASSP2021"
        };
        _this.toggleChallenge = function (challenge) {
            if (challenge == "Interspeech2020") {
                _this.handleChange("Interspeech2020");
            }
            else {
                _this.handleChange("ICASSP2021");
            }
        };
        _this.toggle = function () {
            _this.setState({
                isOpen: !_this.state.isOpen
            });
        };
        return _this;
    }
    NavMenu.prototype.handleChange = function (e) {
        this.props.onChallengeChange(e);
        this.setState(function () { return ({ challengeHack: e }); }, function () { window.location.href = "/" + e; });
        console.log("Will force update now");
        this.forceUpdate();
    };
    NavMenu.prototype.render = function () {
        var _this = this;
        var title = "Deep Noise Suppression Challenge - ICASSP 2021";
        if (this.state.challengeHack == "ICASSP2021" && window.location.pathname.match("Interspeech2020")) {
            this.state.challengeHack = "Interspeech2020";
            console.log("URL contains interspeech but prop contains default ICASSP so setting it to Interspeech back");
        }
        else if (this.state.challengeHack == "Interspeech2020" && window.location.pathname.match("ICASSP2021")) {
            this.state.challengeHack = "ICASSP2021";
            console.log("URL contains ICASSP2021 but prop contains default Interspeech so setting it to ICASSP2021 back");
        }
        var navItems = [
            {
                link: "/",
                text: "Home"
            },
            {
                link: "/rules/",
                text: "Rules"
            },
            {
                link: "/timeline/",
                text: "Timeline"
            },
            {
                link: '/organizers/',
                text: "Organizers"
            },
            {
                link: '/quicklinks/',
                text: "QuickLinks"
            },
            {
                link: '/dnsmos/',
                text: "DNSMOS"
            }
        ];
        var dropDownItem = [];
        var interspeechLogo = React.createElement("img", { width: "100px", src: "https://noisesuppeastusblobstore.blob.core.windows.net/interspeech2020/topright1.png" });
        if (this.state.challengeHack != "ICASSP2021") {
            navItems.push({
                link: '/phase2results/', text: "FinalResults"
            });
            title = "Deep Noise Suppression Challenge - Interspeech 2020";
            dropDownItem.push({ title: "ICASSP 2021", toggleKey: "ICASSP2021" });
        }
        else {
            dropDownItem.push({ title: "Interspeech 2020", toggleKey: "Interspeech2020" });
            interspeechLogo = React.createElement("div", null);
        }
        var navBrandLink = "/" + this.state.challengeHack;
        return (React.createElement("header", null,
            React.createElement(reactstrap_1.Navbar, { className: "navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3", light: true },
                React.createElement(reactstrap_1.Container, null,
                    React.createElement("img", { width: "200px", src: "https://noisesuppeastusblobstore.blob.core.windows.net/interspeech2020/Microsoft-Logo-2012.jpg" }),
                    React.createElement(reactstrap_1.NavbarBrand, { tag: react_router_dom_1.Link, to: navBrandLink, title: title }),
                    React.createElement(reactstrap_1.NavbarToggler, { onClick: this.toggle, className: "mr-2" }),
                    React.createElement(reactstrap_1.Collapse, { className: "d-sm-inline-flex flex-sm-row-reverse", isOpen: this.state.isOpen, navbar: true },
                        React.createElement("ul", { className: "navbar-nav flex-grow" },
                            navItems.map(function (objLink, i) {
                                var modifiedLink = "" + objLink.link + _this.state.challengeHack;
                                return (React.createElement(reactstrap_1.NavItem, { key: i },
                                    " ",
                                    React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, className: "text-dark", to: modifiedLink }, objLink.text)));
                            }),
                            React.createElement(reactstrap_1.Dropdown, { isOpen: this.state.isOpen, toggle: this.toggle },
                                React.createElement(reactstrap_1.DropdownToggle, { caret: true }, this.state.challengeHack),
                                dropDownItem.map(function (dropObjLink, i) {
                                    if (dropObjLink.toggleKey == "ICASSP2021") {
                                        return (React.createElement(reactstrap_1.DropdownMenu, null,
                                            React.createElement(reactstrap_1.DropdownItem, { onClick: function () { return _this.toggleChallenge("ICASSP2021"); } }, dropObjLink.title)));
                                    }
                                    else {
                                        return (React.createElement(reactstrap_1.DropdownMenu, null,
                                            React.createElement(reactstrap_1.DropdownItem, { onClick: function () { return _this.toggleChallenge("Interspeech2020"); } }, dropObjLink.title)));
                                    }
                                })),
                            React.createElement(reactstrap_1.NavItem, null))),
                    interspeechLogo))));
    };
    return NavMenu;
}(React.PureComponent));
exports.default = NavMenu;
//# sourceMappingURL=NavMenu.js.map